<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div class="float-lg-left col-lg-8">
                <div id="accordionFilter" class="content">
                    <div class="card">
                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                             data-parent="#accordionFilter">
                            <div class="card-body">
                                <form>
                                    <em-filter :entity="modelName" ref="emListFilter" @doQuery="afterReloadRows"
                                               @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                               @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="emAclUserResultTable" class="content">
                    <div class="card my-1">
                        <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                             data-parent="#accordionResult">
                            <div class="card-body">
                                <em-table :entity="modelName" import-enabled
                                          ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                          withCustomRowActions
                                          :with-custom-row-actions-first-column="currentIsAdmin"
                                          @doPagination="afterReloadRows"
                                          @sortByColumn="afterReloadRows"
                                          @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                          @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"
                                          @linkClick="whenLinkClick">
                                    <template #customRowActionsFirstColumn="{row}">
                                        <mini-button @btnClick="depute(row.loginName)">
                                            Depute
                                        </mini-button>
                                    </template>
                                    <template slot="customRowActions" slot-scope="customRowScope">
                                        <b-button-group>
                                            <em-button type="gotoChild"
                                                       :class="toAclHolderClass(customRowScope.row.id)"
                                                       customLabel="权限查询"
                                                       showName
                                                       @click="getUserAclTreeNodes(customRowScope.row.id)">
                                            </em-button>
                                            <em-button type="gotoChild"
                                                       :class="toRoleHolderClass(customRowScope.row.id)"
                                                       customLabel="角色管理"
                                                       showName
                                                       @click="getUserRoleTreeNodes(customRowScope.row.id)">
                                            </em-button>
                                        </b-button-group>
                                    </template>
                                </em-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="float-lg-right col-lg-4">
                <em-z-tree v-if="toAcls" ref="userAclEmZTree" :treeNodes="userAclTreeNodes" :chkboxType="chkboxType"
                           checkEnable enableSearch>
                </em-z-tree>
                <!--                :nodeAppender="appendIcon2UserNodes"-->
                <em-z-tree v-if="toRoles" ref="userRoleEmZTree"
                           :treeNodes="userRoleTreeNodes" :chkboxType="chkboxType" enableSearch
                           checkEnable>
                </em-z-tree>
                <div class="row">
                    <div class="col-lg-12 align-self-end">
                        <div class="float-lg-right">
                            <em-button key="userSave" v-if="toRoles" type="save" show-name
                                       v-bind:class="'btn btn-primary'"
                                       v-on:click="saveUserRoles"></em-button>
                            <em-button key="userCancel" v-if="toRoles" type="cancel" show-name
                                       v-bind:class="'btn btn-outline-secondary mr-1'"
                                       v-on:click="getUserRoleTreeNodes"></em-button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author YuJiaBei
// Date 2020-08-20 11:06:30

import {createHelpers} from "vuex-map-fields";
import emCommonListMixin from "@/mixin/em/common/list";
import EmZTree from "@/components/em/EmZTree";
import commonViewsUtil from "@/utils/commonViewsUtil";
import MiniButton from "@/components/common/buttons/MiniButton.vue";

const modelName = "emAclRole";

// create a helper to generate getters and setters with namespace
const {mapFields} = createHelpers({
    getterType: modelName + '/getField',
    mutationType: modelName + '/updateField',
});
export default {
    name: "emAclUserListView",
    mixins: [emCommonListMixin],
    components: {MiniButton, EmZTree},
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        ...mapFields(['baseModuleUrl'])
    },
    mounted() {
        if (this.$route.query.hasOwnProperty('userGroupId')) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('userGroupIdFilter', this.$route.query.userGroupId);
        }
        this.$refs["emListFilter"].doQuery();
        this.checkIfAdmin();
    },
    data() {
        return {
            toAcls: false,
            toRoles: false,
            userAclTreeNodes: [],
            userRoleTreeNodes: [],
            selectUserId: -1,
            chkboxType: {"Y": "s", "N": "s"}, //父节点可以连带子节点，子节点不连带父节点
            currentIsAdmin: false,
        }
    },
    methods: {
        getUserAclTreeNodes(userId) {
            //设置当前选中角色Id，保存时要用到
            this.selectUserId = userId
            let url = this.baseModuleUrl + "/emAclRoleAcl/userAclTree" + "?userId=" + userId
            this.$store.dispatch("api/get", {url})
                .then(data => {
                    this.userAclTreeNodes = data
                    this.showUserAclTree()
                });
        },
        getUserRoleTreeNodes(userId) {
            //设置当前选中角色Id，保存时要用到
            if (userId) {
                this.selectUserId = userId
            }
            let url = this.baseModuleUrl + "/emAclRoleUser/userRoleTree" + "?userId=" + this.selectUserId
            this.$store.dispatch("api/get", {url})
                .then(data => {
                    this.userRoleTreeNodes = data
                    this.showUserRoleTree()
                });
        },
        showUserAclTree() {
            this.toAcls = true;
            this.toRoles = false;
        },
        showUserRoleTree() {
            this.toRoles = true;
            this.toAcls = false;
        },
        saveUserRoles() {
            if (this.selectRoleId === -1) {
                commonViewsUtil.showWarning(this, "保存用户与角色的关系,请先在左侧选择需要操作的用户")
                return;
            }
            let url = this.baseModuleUrl + "/emAclRoleUser/userRoleTree"
            this.$store.dispatch("api/put", {
                url,
                entity: {
                    userId: this.selectUserId,
                    roleIds: this.getRoleIds(this.$refs['userRoleEmZTree'].getCheckedNodes())

                }
            }).then(response => commonViewsUtil.showSuccess(this, "保存用户与角色关系,操作成功"))
        },
        getRoleIds(roleNodes) {
            var v = "";
            for (var i = 0; i < roleNodes.length; i++) {
                // if(aclNodes[i].id.startsWith(aclPrefix)) {
                v += "," + roleNodes[i].id;
                // }
            }
            return v.length > 0 ? v.substring(1) : v;
        },
        //todo 改造为拼装角色名：读写权限 | 部门控制权限
        appendIcon2UserNodes(roleUserTreeNode) {
            let userPrefix = "user_"
            let deptPrefix = "dept_"
            if (roleUserTreeNode.id.startsWith(userPrefix)) {
                return Object.assign({iconSkin: "iconUser"}, roleUserTreeNode)
            } else if (roleUserTreeNode.id.startsWith(deptPrefix)) {
                if (!roleUserTreeNode.isParent)
                    return Object.assign({iconSkin: "iconBuilding"}, roleUserTreeNode)
                else
                    return Object.assign({iconSkin: "pIconBuilding"}, roleUserTreeNode)
            }
        },
        toAclHolderClass(userId) {
            if (this.toAcls && this.selectUserId && this.selectUserId === userId) {
                return "btn btn-success btn-sm";
            } else {
                return "btn btn-outline-primary btn-sm"
            }
        },
        toRoleHolderClass(userId) {
            if (this.toRoles && this.selectUserId && this.selectUserId === userId) {
                return "btn btn-success btn-sm";
            } else {
                return "btn btn-outline-primary btn-sm"
            }
        },
        afterReloadRows() {
            //重新执行了查询，就初始化右侧两棵树相关数据
            this.toAcls = false
            this.toRoles = false
            this.userAclTreeNodes = []
            this.userRoleTreeNodes = []
            this.selectUserId = -1
        },
        whenLinkClick(key, row) {
            this.$router.push("/em/admin/emEmAdmUserGroupList?userGroupId=" + row.userGroupId);
        },

        checkIfAdmin() {
            this.$store.dispatch("api/get", {
                url: process.env.VUE_APP_EM_ADMIN_URL + "/emAclUser/currentUser"
            }).then(data => {
                if (data && data.loginName === "admin") {
                    this.currentIsAdmin = true;
                }
            })
        },

        depute(loginName) {
            this.$store.dispatch("api/post", {
                url: process.env.VUE_APP_EM_ADMIN_URL + "/sso/depute/login?userLoginName=" + loginName,
                data: {}
            }).then(res => {
                console.log(res);
                if (res && res.data) {
                    localStorage['em_sso_token'] = res.data;
                    localStorage.removeItem('hideNoAuthMessage')
                    window.location.reload();
                }
            })
        },
    }
};
</script>
